import { render, staticRenderFns } from "./Editable.vue?vue&type=template&id=f517c942&scoped=true&"
import script from "./Editable.vue?vue&type=script&lang=js&"
export * from "./Editable.vue?vue&type=script&lang=js&"
import style0 from "./Editable.vue?vue&type=style&index=0&id=f517c942&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f517c942",
  null
  
)

export default component.exports